"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clsx = exports.cx = void 0;
var tslib_1 = require("tslib");
var css_1 = require("@emotion/css");
var useHoustonTheme_1 = tslib_1.__importDefault(require("../useHoustonTheme"));
exports.cx = css_1.cx;
exports.clsx = css_1.cx;
/**
 * @deprecated Migrate to styled
 */
function createUseStyles(generator) {
    return function (props) {
        var styles;
        if (typeof generator === 'function') {
            var theme = (0, useHoustonTheme_1.default)();
            styles = generator(theme);
        }
        else {
            styles = generator;
        }
        return Object.keys(styles).reduce(function (acc, key) {
            var _a;
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[key] = (0, css_1.css)(typeof styles[key] === 'function' ? styles[key](props) : styles[key]), _a));
        }, {});
    };
}
exports.default = createUseStyles;
